export default __webpack_public_path__ + "static/media/subscriptions.aa54e23c.svg";